// 이벤트(카드게임) 기능 제외 처리로 화면을 노출하지 않는다.
const EventPopup = () => null;

export default EventPopup;
